import { LocationPaths, OnboardingPath } from 'location.types'
import { RouteObject } from 'react-router'
import { getOnboardingFlow } from 'screens/Onboarding/types'

export const onboarding: RouteObject = {
  path: LocationPaths.Onboarding,

  children: [
    {
      index: true,
      lazy: async () => ({
        Component: (await import('screens/Onboarding/Entrypoint')).Entrypoint
      })
    },
    {
      lazy: async () => ({
        Component: (await import('components/OnboardingFlowStep/Layout')).Layout
      }),
      children: (() => {
        const flow = getOnboardingFlow()
        const preConfirmationIndex = flow.length - 1

        return [
          ...flow.map((step, index) => ({
            path: step.path,
            lazy: step.lazy,
            handle: { index }
          })),
          {
            path: OnboardingPath.FreeCallInfo,
            handle: { index: preConfirmationIndex },
            lazy: async () => ({
              Component: (await import('screens/Onboarding/OnboardingFreeCallInfo'))
                .OnboardingFreeCallInfo
            })
          },
          {
            path: OnboardingPath.PaidCallInfo,
            handle: { index: preConfirmationIndex },
            lazy: async () => ({
              Component: (await import('screens/Onboarding/OnboardingPaidCallInfo'))
                .OnboardingPaidCallInfo
            })
          },
          // Upsell Offers routes
          {
            path: OnboardingPath.UpsellOffer,
            handle: { index: preConfirmationIndex },
            lazy: async () => ({
              Component: (await import('screens/Onboarding/UpsellOffers/UpsellOffer')).UpsellOffer
            })
          },
          {
            path: OnboardingPath.UpsellOfferConfirmation,
            handle: { index: preConfirmationIndex },
            lazy: async () => ({
              Component: (await import('screens/Onboarding/UpsellOffers/UpsellOfferConfirmation'))
                .UpsellOfferConfirmation
            })
          },
          {
            path: OnboardingPath.UpsellSelectCoach,
            handle: { index: preConfirmationIndex },
            lazy: async () => ({
              Component: (await import('screens/Onboarding/UpsellOffers/UpsellSelectCoach'))
                .UpsellSelectCoach
            })
          },
          {
            path: OnboardingPath.UpsellScheduleCall,
            handle: { index: preConfirmationIndex },
            lazy: async () => ({
              Component: (await import('screens/Onboarding/UpsellOffers/UpsellScheduleCall'))
                .UpsellScheduleCall
            })
          },
          {
            path: OnboardingPath.UpsellCheckout,
            handle: { index: preConfirmationIndex },
            lazy: async () => ({
              Component: (await import('screens/Onboarding/UpsellOffers/UpsellCheckout'))
                .UpsellCheckout
            })
          },
          {
            path: OnboardingPath.UpsellMicrobiome,
            handle: { index: preConfirmationIndex },
            lazy: async () => ({
              Component: (await import('screens/Onboarding/UpsellOffers/MicrobiomeOffer'))
                .MicrobiomeOffer
            })
          },
          {
            path: OnboardingPath.AppointmentOfferConfirmation,
            handle: { index: preConfirmationIndex },
            lazy: async () => ({
              Component: (
                await import('screens/Onboarding/UpsellOffers/AppointmentOfferConfirmation')
              ).AppointmentOfferConfirmation
            })
          }
        ]
      })()
    }
  ]
}
